import React from 'react';
import PropTypes from 'prop-types';
import isNil from 'utils/isNil';
import styled from 'styled-components';
import { SectionLayout } from 'components/Sections/SectionLayout';
import { WebsiteImage } from 'components/TitleDescription';
import Video from 'components/Video';
import Text from 'components/Text';
import WistiaVideo from 'components/WistiaVideo';

const SingleSection = ({
  title,
  imgs,
  video,
  videoType,
  description,
  backgroundColor,
  bgImg,
  path,
  className,
}) => {
  const childClassName = path ? path.split('/').join('') : null;
  return (
    <SingleSectionLayout
      backgroundColor={backgroundColor}
      backgroundImg={!isNil(bgImg) ? bgImg.file.url : null}
      className={className}
    >
      <div style={{ textAlign: 'center' }} className={childClassName}>
        {!isNil(description) && description.includes('wistia') ? (
          <Text
            type="h2"
            className="text-title"
            style={{ marginTop: '96px' }}
            color={backgroundColor === 'Dark Blue' ? 'white' : null}
          >
            {title}
          </Text>
        ) : (
          <Text
            type="h2"
            className="text-title"
            color={backgroundColor === 'Dark Blue' ? 'white' : null}
          >
            {title}
          </Text>
        )}

        {!isNil(description) ? (
          description.includes('wistia') ? (
            <WistiaVideo
              url={description}
              size="Large"
              wrapperStyles={{
                position: 'relative',
                right: '0px',
                top: '0px',
                margin: '32px auto 0 auto',
              }}
            />
          ) : (
            <p fontSize="normal" className="text-description">
              {description}
            </p>
          )
        ) : null}
        {!isNil(imgs) && (
          <div className="img--content--area">
            {imgs.length > 1 &&
              imgs.map((img, index) => {
                return (
                  <div className="img--content--item" key={index}>
                    <WebsiteImage src={img} className="single-section--image" />
                  </div>
                );
              })}
            {imgs.length == 1 && (
              <WebsiteImage
                src={imgs[0]}
                className={childClassName + '-image' + ' single-section--image'}
              />
            )}
          </div>
        )}
        {!isNil(video) && (
          <div className="section-video-hero--main">
            <div className="section-video--content">
              <Video
                type={videoType === 'featureSection' ? 'preview-only' : 'normal'}
                height="485px"
                mainSrc={video.file.url}
                previewSrc={video.file.url}
              />
            </div>
          </div>
        )}
      </div>
    </SingleSectionLayout>
  );
};

SingleSection.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  imgs: PropTypes.array,
  backgroundColor: PropTypes.string,
  bgImg: PropTypes.object,
};

const SingleSectionLayout = styled(SectionLayout)`
  .pro,
  .solutions,
  .watersoftware,
  .cuc {
    padding-top: 108px;
  }
  .pro-image.single-section--image {
    max-height: 300px;
    margin: 0 auto !important;
  }
  .watersoftware-image.single-section--image,
  .cuc-image.single-section--image {
    max-width: 750px;
    margin: 0 auto !important;
  }
  .text-title {
    font-size: 49px;
    font-weight: 900;
    line-height: 110%;
    letter-spacing: -0.04em;
  }

  .text-description {
    font-weight: 500;
    font-size: 20px;
    line-height: 150%;
    max-width: 782px;
    margin: 24px auto;
  }

  .img--content--area {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 64px;
    padding: 0 28px;
    .img--content--item {
      width: 135px;

      .single-section--image {
        text-align: center;
      }
    }
  }

  .wistia_embed {
    position: relative;

    .w-bottom-bar {
      display: block !important;
    }

    .w-big-play-button {
      display: block !important;
    }
  }

  .section-video-hero--main {
    max-width: 1200px;
    margin: 0 auto;
    margin-top: 40px;
    .section-video--content {
      margin-left: auto;
      margin-right: auto;
      max-width: 640px;
      position: relative;
    }
  }
  @media (max-width: 1200px) {
    .img--content--area .img--content--item {
      width: 125px;
    }
  }
  @media (max-width: 768px) {
    .img--content--area .img--content--item {
      padding: 0px 10px;
    }
    .text-title {
      font-size: 29px;
      letter-spacing: -0.03em;
    }
    .text-description {
      font-size: 17px;
      margin-top: 16px;
    }
    .img--content--area {
      margin-top: 15px;
    }
    .section-video-hero--main {
      .section-video--content {
        margin-left: auto;
        margin-right: auto;
        width: 415.7px;
      }
    }
  }
  @media (max-width: 576px) {
    .img--content--area .img--content--item {
      margin: 48px 15px 0;
    }
    .img--content--area {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      flex-direction: row;

      img {
        object-fit: contain;
      }
    }
  }
`;

export default SingleSection;
